import z from 'zod'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'
import { toStandardSchema } from '../utils/schema'

export const HARMONY_PACKAGE_BOARD_WORKITEM_TABLE = '"public"."harmonyPackageBoardWorkitems"'

export const HarmonyPackageBoardWorkitemFetchSchema = z.object({
  id: z.string().default(''),
  board_id: z.string().min(5, 'Board ID is required'),
  column_id: z.string().min(5, 'Column ID is required'),
  workitem_id: z.string().min(5, 'Workitem ID is required').nullish(),
  position: z.number().default(0).optional(),
  workspace_id: z.uuid('Workspace ID must be a valid UUID').nullish(),
  history: z.array(z.any()).optional(),
})

export const HarmonyPackageBoardWorkitemSchema = toStandardSchema(HarmonyPackageBoardWorkitemFetchSchema)

export const HarmonyPackageBoardWorkitemConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: HARMONY_PACKAGE_BOARD_WORKITEM_TABLE,
  partitionKey: 'board_id',
  key: 'id',
  apiEndpoint: '/api/board-workitems',
  where: {},
  schema: HarmonyPackageBoardWorkitemSchema,
}
